export function getParams(state) {
    return state.params
}

export function subCategoriesList(state) {
    return state.subCategoriesList;
}


// WEBPACK FOOTER //
// ./src/modules/subcategories/getters.js